import React from 'react';

import styles from './CompetitionDurationInput.module.css';

export const CompetitionDurationInputDash = () => {
  return <div className={styles.CompetitionDurationInput__Dash} />;
};
